var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defer, each } from 'lodash-es';
import Component from 'navigation/component/Component';
import capency, { CAPENCY_DEFAULT_COUNTRIES } from 'helpers/capency';
import config from 'core/config';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import GooglePlacesField from 'components/address-field/GooglePlacesField';
import CapencyField from 'components/address-field/CapencyField';
var AddressForm = /** @class */ (function (_super) {
    __extends(AddressForm, _super);
    function AddressForm(el, options) {
        var _this = _super.call(this, el, options) || this;
        Object.defineProperty(_this, "prefix", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "stateInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "countryInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "statesByCountry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "form", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'empty'
        });
        Object.defineProperty(_this, "suggestions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "capencyCountries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: CAPENCY_DEFAULT_COUNTRIES
        });
        Object.defineProperty(_this, "_useCapency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(_this, "selectedAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(_this, "onCountryUpdate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var _a, _b;
                if (!_this.stateInput)
                    return;
                var country = _this.countryInput.value;
                _this.useCapency = (_a = _this.capencyCountries) === null || _a === void 0 ? void 0 : _a.includes(country);
                var states = _this.statesByCountry[country];
                if (_this.modules.capencyField)
                    _this.modules.capencyField.country = country;
                if (_this.modules.googlePlacesField)
                    _this.modules.googlePlacesField.country = country;
                _this.el.classList.toggle('with-states', !!states);
                _this.el.classList.toggle('without-zipcode', country === 'HK');
                _this.stateInput.innerHTML = '';
                _this.status = 'empty';
                _this.selectedAddress = null;
                if (country === 'MC') {
                    _this.fillAddress({
                        city: 'MONACO'
                    });
                }
                (_b = _this.el.querySelector('.address__choices')) === null || _b === void 0 ? void 0 : _b.remove();
                // this.status = 'empty'
                // this.selectedAddress = null
                _this.form.quickValid();
                if (!states)
                    return;
                each(states, function (value, key) {
                    var option = document.createElement('option');
                    option.value = key.toString();
                    option.textContent = value;
                    option.selected = _this.stateInput.getAttribute('value') === key.toString();
                    _this.stateInput.appendChild(option);
                });
                _this.form.quickValid();
            }
        });
        Object.defineProperty(_this, "onAddressInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var _a;
                (_a = _this.el.querySelector('.address__choices')) === null || _a === void 0 ? void 0 : _a.remove();
                _this.status = 'empty';
                _this.selectedAddress = null;
            }
        });
        Object.defineProperty(_this, "onAddressSelected", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (address) {
                _this.selectedAddress = address;
                _this.fillAddress(address);
            }
        });
        Object.defineProperty(_this, "verifyAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var args_1 = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args_1[_i] = arguments[_i];
                }
                return __awaiter(_this, __spreadArray([], __read(args_1), false), Promise, function (forced) {
                    var values, address_1, _a, addresses, error, address, suggestedAddresses, notAMatch, addressesChoice, addressesChoice;
                    var _this = this;
                    var _b;
                    if (forced === void 0) { forced = false; }
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                if (!this.useCapency)
                                    return [2 /*return*/, true];
                                if (forced) {
                                    this.fillAddress(this.selectedAddress);
                                    this.form.submit();
                                }
                                values = (this.prefix ? this.form.getAddressFormValues(this.el) : this.form.getFormValues());
                                // If user selected a suggested address
                                if (values.address_final_choice) {
                                    // if a user wish to keep the address he entered
                                    if (values.address_final_choice === '-1') {
                                        this.status = 'validated';
                                        return [2 /*return*/, true];
                                    }
                                    address_1 = this.suggestions[parseInt(values.address_final_choice)];
                                    this.fillAddress({
                                        address: "".concat(address_1.streetNumber || '', " ").concat(address_1.streetName),
                                        city: address_1.locality,
                                        postcode: address_1.postalCode
                                    });
                                    this.status = 'validated';
                                    return [2 /*return*/, true];
                                }
                                return [4 /*yield*/, capency.verifyAddress({
                                        streetName: "".concat(values.address),
                                        postalCode: "".concat(values.postcode),
                                        locality: values.city,
                                        country: values.country
                                    })
                                    // Remove older address suggestions
                                ];
                            case 1:
                                _a = _c.sent(), addresses = _a.addresses, error = _a.error;
                                // Remove older address suggestions
                                (_b = this.el.querySelector('.address__choices')) === null || _b === void 0 ? void 0 : _b.remove();
                                address = addresses === null || addresses === void 0 ? void 0 : addresses.address;
                                if (!error && address) {
                                    suggestedAddresses = address.filter(function (address) { return address.qualityCode !== '20'; });
                                    notAMatch = address.length === 1 && (address === null || address === void 0 ? void 0 : address[0]) && ((values.address !== "".concat(address[0].streetNumber || '', " ").concat(address[0].streetName)) || (values.postcode !== address[0].postalCode) || (values.city !== address[0].locality));
                                    if (suggestedAddresses.length > 1 || notAMatch) {
                                        this.suggestions = suggestedAddresses;
                                        addressesChoice = "\n        <div class=\"address__choices\">\n          <h3>".concat(address.length === 1 ? config.errors.capencyNotSure : config.errors.capencySuggestedAddress, "</h3>\n          <div class=\"address__choices-list\">\n            ").concat(suggestedAddresses.map(function (address, index) { return "\n              <div class=\"radio\">\n                <input type=\"radio\" class=\"radio__input\" name=\"".concat(_this.prefix ? _this.prefix + '[' : '', "address_final_choice").concat(_this.prefix ? ']' : '', "\" id=\"choice").concat(index, "\" value=\"").concat(index, "\" required>\n                <div class=\"radio__box\"></div>\n                <label class=\"radio__label\" for=\"choice").concat(index, "\">").concat(address.streetNumber || '', " ").concat(address.streetName, ", ").concat(address.postalCode, " ").concat(address.locality, "</label>\n              </div>\n            "); }).join(''), "\n             <div class=\"radio\">\n                <input type=\"radio\" class=\"radio__input\" name=\"").concat(this.prefix ? this.prefix + '[' : '', "address_final_choice").concat(this.prefix ? ']' : '', "\" id=\"choice-keep\" value=\"-1\" required>\n                <div class=\"radio__box\"></div>\n                <label class=\"radio__label\" for=\"choice-keep\">").concat(config.errors.capencyKeep, " (").concat(values.address, " ").concat(values.postcode, " ").concat(values.city, ")</label>\n              </div>\n          </div>\n        </div>");
                                        this.el.lastElementChild.insertAdjacentHTML('beforebegin', addressesChoice);
                                        this.status = 'pending_selection';
                                        return [2 /*return*/, false];
                                    }
                                    if (address.length === 1) {
                                        // 00 Valid address
                                        // 04 Forced company possessing a CEDEX (business postcode)
                                        // 10 Uncertain address
                                        if (['00', '04', '10'].includes(address[0].qualityCode)) {
                                            this.status = 'validated';
                                            this.fillAddress({
                                                address: "".concat(address[0].streetNumber || '', " ").concat(address[0].streetName),
                                                address2: "".concat(address[0].buildingName || '__IGNORE__'),
                                                city: address[0].locality,
                                                postcode: address[0].postalCode
                                            });
                                            return [2 /*return*/, true];
                                        }
                                        else {
                                            addressesChoice = "\n          <div class=\"address__choices\">\n            <h3>".concat(config.errors.capencyNotSure, "</h3>\n              <div class=\"radio\">\n                <input type=\"radio\" class=\"radio__input\" name=\"address_final_choice\" id=\"choice-keep\" value=\"-1\" required>\n              </div>\n              <span class=\"address__choice\">").concat(address[0].streetNumber || '', " ").concat(address[0].streetName, ", ").concat(address[0].postalCode, " ").concat(address[0].locality, "</span>\n              <button type=\"button\" value=\"").concat(config.errors.capencyConfirm, "\" data-ref=\"confirmIncompleteAddress\" data-text=\"").concat(config.errors.capencyConfirm, "\" class=\"button button__hover-classic button__solid button__dark\">\n                <span class=\"button__inner\">\n                  <span class=\"button__text-wrapper\">\n                    <span class=\"button__text-inner\" data-hover=\"").concat(config.errors.capencyConfirm, "\"><span>").concat(config.errors.capencyConfirm, "</span></span>\n                  </span>\n                </span>\n              </button>\n            </div>\n          </div>");
                                            this.el.lastElementChild.insertAdjacentHTML('beforebegin', addressesChoice);
                                            this.bindEvents(false);
                                            this.bindRefs();
                                            this.bindEvents(true);
                                            this.status = 'pending_selection';
                                            this.fillAddress({
                                                address: "".concat(address[0].streetNumber || '', " ").concat(address[0].streetName),
                                                city: address[0].locality,
                                                postcode: address[0].postalCode
                                            });
                                            return [2 /*return*/, false];
                                        }
                                    }
                                }
                                else {
                                    console.log('error', error);
                                }
                                return [2 /*return*/];
                        }
                    });
                });
            }
        });
        Object.defineProperty(_this, "fillAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (address) {
                each(address, function (value, key) {
                    var name = _this.prefix ? "".concat(_this.prefix, "[").concat(key, "]") : key;
                    var input = _this.el.querySelector("[name=\"".concat(name, "\"]"));
                    if (!input || value === '__IGNORE__')
                        return;
                    input.value = value;
                    if (key === 'country')
                        _this.onCountryUpdate();
                });
            }
        });
        _this.form = _this.parent;
        defer(function () {
            var _a;
            if (((_a = _this.parent) === null || _a === void 0 ? void 0 : _a.name) !== 'Form')
                throw new Error('AddressForm must be a child of a Form');
        });
        _this.prefix = el.getAttribute('data-prefix');
        var country = _this.el.querySelector('select[autocomplete="country"]');
        _this._useCapency = _this.capencyCountries.includes(country === null || country === void 0 ? void 0 : country.value);
        _this.parseForm();
        return _this;
    }
    Object.defineProperty(AddressForm.prototype, "useCapency", {
        get: function () {
            return this._useCapency;
        },
        set: function (value) {
            if (this._useCapency !== value) {
                this._useCapency = value;
                this.fillAddress({
                    address: '',
                    address2: '',
                    city: '',
                    postcode: ''
                });
            }
            this.refresh();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddressForm.prototype, "initialized", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            _super.prototype.initialized.call(this);
            this.getCapencyAvailableCountries();
        }
    });
    Object.defineProperty(AddressForm.prototype, "getCapencyAvailableCountries", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var countries, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.onCountryUpdate();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, capency.getAvailableCountries()];
                        case 2:
                            countries = _a.sent();
                            this.capencyCountries = countries;
                            this.onCountryUpdate();
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _a.sent();
                            this.onCountryUpdate();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(AddressForm.prototype, "getModulesMap", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this.useCapency) {
                return {
                    capencyField: ['input[autocomplete="street-address"]', CapencyField]
                };
            }
            else {
                return {
                    googlePlacesField: ['input[autocomplete="street-address"]', GooglePlacesField]
                };
            }
        }
    });
    Object.defineProperty(AddressForm.prototype, "bindEvents", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (add) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (add === void 0) { add = true; }
            var method = bindMethod(add);
            var emitterMethod = bindEmitterMethod(add);
            this.countryInput[method]('change', this.onCountryUpdate);
            if (this.useCapency) {
                (_b = (_a = this.modules) === null || _a === void 0 ? void 0 : _a.capencyField) === null || _b === void 0 ? void 0 : _b[emitterMethod]('select', this.onAddressSelected);
                (_d = (_c = this.modules) === null || _c === void 0 ? void 0 : _c.capencyField) === null || _d === void 0 ? void 0 : _d[emitterMethod]('input', this.onAddressInput);
                if (this.refs.confirmIncompleteAddress)
                    this.refs.confirmIncompleteAddress[method]('click', this.verifyAddress.bind(this, true));
            }
            else {
                (_f = (_e = this.modules) === null || _e === void 0 ? void 0 : _e.googlePlacesField) === null || _f === void 0 ? void 0 : _f[emitterMethod]('select', this.onAddressSelected);
                (_h = (_g = this.modules) === null || _g === void 0 ? void 0 : _g.googlePlacesField) === null || _h === void 0 ? void 0 : _h[emitterMethod]('input', this.onAddressInput);
            }
            this.form[emitterMethod]('submit', this.verifyAddress.bind(this));
        }
    });
    Object.defineProperty(AddressForm.prototype, "parseForm", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.stateInput = this.el.querySelector('select[autocomplete="address-level1"]');
            if (!this.stateInput)
                return;
            this.statesByCountry = JSON.parse(this.stateInput.getAttribute('data-states'));
            this.countryInput = this.el.querySelector('select[autocomplete="country"]');
        }
    });
    return AddressForm;
}(Component));
export default AddressForm;
